import Link from 'next/link';
import { FaRegStar, FaStar } from 'react-icons/fa6';
import NextImage from '@/features/Image';
import CartButton from '@/features/home/Flash_sales/components/CartButton';
import ProductDetailsWishlist from '@/features/product-details/components/ProductDetailsWishlist';

const ProductCard = ({ data }: { data: any }) => {
  const url = data?.influencer_id
    ? `/product/${data?.slug}?influencer_id=${data?.influencer_id}`
    : `/product/${data?.slug}`;
  return (
    <div className="product__item product__item--style2">
      <div className="product__item-inner">
        {data.discount > 0 && (
          <div className="product__item-badge">-{data.discount}%</div>
        )}

        <div className="product__item-wishlist">
          <ProductDetailsWishlist product={data} />
        </div>

        {data.new && (
          <div className="product__item-badge product__item-badge--new">
            New
          </div>
        )}
        <div className="product__item-thumb">
          <NextImage
            width={237}
            height={175}
            src={data?.pictures?.[0]?.url}
            alt={data?.name || 'Product Image'} // Better alt text
            unoptimized={true}
          />
        </div>
        <div className="product__item-content">
          <h6 className="fw-semibold">
            <Link href={`${url}`}>{data.name}</Link>
          </h6>
          {/* <div className="product__item-rating">
            <span>
              <FaStar className="mb-1" /> {data.ratings}
            </span>{' '}
            <span>({data.reviews} Reviews)</span>
          </div> */}

          <div className="product__item-rating">
            <span>
              {[1, 2, 3, 4, 5].map((star) =>
                star <= Math.round(data.ratings) ? (
                  <FaStar key={star} />
                ) : (
                  <FaRegStar key={star} className="text-gray-300" />
                )
              )}
            </span>
            {/* <span>({data.reviews} Reviews)</span> */}
            {data?.reviews > 0 && (
              <span className="fs-small"> ({data?.reviews})</span>
            )}
          </div>

          <div className="product__item-footer">
            <div className="product__item-price">
              <h6 className="fw-medium fs-small">
                ৳{Number(data?.sale_price).toFixed(0)}
                {data?.discount > 0 && '/'}{' '}
                {data?.discount > 0 && (
                  <span>
                    <del>৳{Number(data?.price).toFixed(0)}</del>
                  </span>
                )}
              </h6>
            </div>
            <div className="product__item-action">
              <CartButton product={data} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
